export default "__VITE_ASSET__DVPBsiw6__"